export default __webpack_public_path__ + "static/media/outlined_heart.c0bdf57f.svg";